import type { DashboardPanelKey } from '@dashai/hooks/useDashboardPanelChat';

interface DashboardPanelInfo {
  name: string;
  suggestions: [string, string, string];
}

// The dashboards that offer the Questions panel. dashaiChat serves the same
// keys and checks each one's per-country scope before answering.
export const DASHBOARD_PANEL_INFO: Readonly<Record<DashboardPanelKey, DashboardPanelInfo>> = {
  execution_view: {
    name: 'Execution View',
    suggestions: [
      'Which outlets have the lowest ONE Performance score?',
      'Where is core availability weakest?',
      'Which platform has the most missing images?',
    ],
  },
  key_accounts: {
    name: 'Key Accounts',
    suggestions: [
      'Which key accounts have the weakest availability?',
      'Which key accounts changed most since last month?',
      'Where are we missing at our biggest key account?',
    ],
  },
};
